<template>
  <div class="marketing-page">
    <top-bar :topbarList="marketingTopBarList"></top-bar>
    <router-view></router-view>
  </div>
</template>

<script>
import topBar from "@/components/topBar.vue";

import { marketingIndexMixins } from "@/mixins/marketingIndexMixins";

export default {
  mixins: [marketingIndexMixins],
  data() {
    return {};
  },
  computed: {},
  components: {
    topBar,
  },
};
</script>

<style lang="less" scoped>
.marketing-page {
  height: 100%;
}
</style>
